import React, { useState } from 'react';
import DiscourseForm from '../DiscourseForm/DiscourseForm';
import DiscourseCareClaimModal from '../DiscourseCareClaim/DiscourseCareClaimModal';
import { useDisclose } from '../../../Modal/Hooks/useDisclose';
import useNotification from '../../../../Hooks/useNotification.hook';
import { DocumentItem } from '../../../../graphql/graphql';

interface Props {
	patientId: string;
	virtualPatientId: string;
	showCreateSickLeaveButton?: boolean;
	onSaveSuccess?: () => void;
}

const DiscourseRecord = ({
	patientId,
	virtualPatientId,
	showCreateSickLeaveButton = false,
	onSaveSuccess,
}: Props) => {
	const [careClaimsListRefreshVersion, setCareClaimsListRefreshVersion] =
		useState(0);

	const {
		isOpen: areCareClaimsOpen,
		onOpen: openCareClaimsModal,
		onClose: closeCareClaimsModal,
	} = useDisclose();
	const { showNotificationAlert } = useNotification();

	const handleOpenCareClaimsModal = (
		_discourseId: string,
		discourseMainDiagnosis?: DocumentItem,
	) => {
		if (!discourseMainDiagnosis) {
			return showNotificationAlert({
				content: 'component.discourse.mainDiagnosisMissing',
			});
		}
		openCareClaimsModal();
	};

	return (
		<>
			<DiscourseForm
				patientId={patientId}
				virtualPatientId={virtualPatientId}
				openCareClaimModal={handleOpenCareClaimsModal}
				careClaimsListRefreshVersion={careClaimsListRefreshVersion}
				showCreateSickLeaveButton={showCreateSickLeaveButton}
				onSaveSuccess={onSaveSuccess}
			/>
			{areCareClaimsOpen && (
				<DiscourseCareClaimModal
					isOpen
					onClose={closeCareClaimsModal}
					patientId={virtualPatientId}
					onSaveSuccess={() => setCareClaimsListRefreshVersion(v => v + 1)}
				/>
			)}
		</>
	);
};

export default DiscourseRecord;
